import React from 'react'

export const EcuadorIcon = (width = 24, height = 24) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_602_7148)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V24H0V0Z"
          fill="#FFE800"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 12H24V24H0V12Z"
          fill="#00148E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 18H24V24H0V18Z"
          fill="#DA0010"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0084 11.4467L7.44434 14.1514L7.39746 14.0951L9.96152 11.3857L10.0084 11.4467ZM11.7896 11.8873L8.43809 15.4217L8.38184 15.3654L11.7334 11.8311L11.7943 11.8873H11.7896Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.48828 15.4248L8.21002 15.7072L7.88862 15.9481L8.12373 15.6242L8.40199 15.3418L8.48828 15.4248Z"
          fill="#808080"
          stroke="black"
          strokeWidth="0.0425298"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.62598 14.042L7.34772 14.3244L7.02631 14.5653L7.26143 14.2414L7.53969 13.959L7.62598 14.042Z"
          fill="#808080"
          stroke="black"
          strokeWidth="0.0425298"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.8331 5.25391C7.8331 5.25391 7.55101 12.9221 8.67938 12.9221C9.80776 12.9221 10.3735 12.1156 10.3735 12.1156L10.3608 7.90109L7.8331 5.25391Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0677495"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.52371 5.96875C8.52371 6.37198 8.3978 12.1151 8.96199 12.1151C9.52618 12.1151 10.3741 11.7119 10.3741 11.7119L10.3613 7.9006L8.52371 5.96875Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0677495"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.88965 6.35645C8.88965 6.75967 8.96137 11.3091 9.52715 11.3091H10.3734L10.3607 7.90101L8.88965 6.35645Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.0677495"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.76738 5.25937L10.3268 7.96406L10.3736 7.90781L7.80957 5.20312L7.7627 5.25937H7.76738Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.02307 6.74316C7.02307 6.74316 6.29294 14.08 8.48332 14.08C10.3086 14.08 10.3086 12.9226 10.6737 12.9226L10.3086 10.2198L7.02101 6.74316H7.02307Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          d="M8.63819 8.04627C8.65314 8.04524 9.19033 6.85209 10.518 6.10621"
          stroke="black"
          strokeWidth="0.0802019"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.55868 6.88272C8.74534 6.9718 8.86294 7.07453 8.96973 7.19438C8.75551 7.14887 8.64493 7.13054 8.45827 7.04145C8.27162 6.95237 8.12977 6.81578 8.01709 6.70527C8.15628 6.7484 8.37099 6.79314 8.55868 6.88272Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0364699"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.13503 7.5725C9.14759 7.59725 9.13387 7.63182 9.10368 7.64857C9.0735 7.66531 9.03873 7.65843 9.02586 7.63306C9.01298 7.60769 9.02733 7.57435 9.05752 7.55761C9.0877 7.54087 9.12247 7.54775 9.13503 7.5725Z"
          fill="#FF0000"
          stroke="black"
          strokeWidth="0.0253814"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.59065 6.10598C9.5092 6.31809 9.41932 6.45806 9.31573 6.58875C9.36226 6.35302 9.38202 6.23203 9.46347 6.01992C9.54492 5.80781 9.66381 5.63728 9.75992 5.50153C9.71846 5.65655 9.67255 5.8927 9.59065 6.10598Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.034563"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.44481 6.10565C9.4253 6.31352 9.38217 6.47467 9.32544 6.63819C9.3103 6.43636 9.29908 6.33552 9.31859 6.12765C9.3381 5.91978 9.39851 5.71722 9.44782 5.55499C9.44868 5.69492 9.46444 5.89664 9.44481 6.10565Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0302635"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.60753 6.38021C9.49724 6.50408 9.40401 6.55619 9.30584 6.5887C9.40353 6.41496 9.45134 6.3224 9.56163 6.19852C9.67193 6.07465 9.79082 6.01887 9.8863 5.97567C9.81591 6.08102 9.71844 6.25566 9.60753 6.38021Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0326215"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.73244 6.75C8.85122 6.90103 8.90683 7.04469 8.94636 7.20279C8.78663 7.08852 8.70205 7.0349 8.58327 6.88388C8.46448 6.73286 8.40265 6.54639 8.35435 6.39616C8.45254 6.48453 8.613 6.59815 8.73244 6.75Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0363119"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.32298 7.63397C8.48418 7.76378 8.56995 7.89798 8.6388 8.0497C8.43454 7.96452 8.32736 7.92635 8.16616 7.79654C8.00495 7.66672 7.90582 7.49062 7.82775 7.34845C7.95587 7.41906 8.16089 7.50345 8.32298 7.63397Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0400078"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.06544 7.57376C8.94242 7.77738 8.80815 7.91486 8.65388 8.04491C8.72597 7.82238 8.75691 7.70853 8.87993 7.50491C9.00295 7.30128 9.18034 7.13298 9.3237 6.99888C9.26033 7.14614 9.18915 7.36901 9.06544 7.57376Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0401468"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.26946 7.77646C9.06414 7.91815 8.88528 7.99054 8.69467 8.04664C8.87007 7.86348 8.95513 7.76706 9.16045 7.62537C9.36577 7.48368 9.59495 7.40097 9.77915 7.33598C9.65078 7.45008 9.47592 7.63399 9.26946 7.77646Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.039891"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6204 5.9728C10.5339 6.07716 10.4559 6.14134 10.3718 6.19872C10.4426 6.07704 10.4765 6.01405 10.5631 5.90969C10.6496 5.80533 10.75 5.72836 10.8308 5.66727C10.778 5.74588 10.7074 5.86787 10.6204 5.9728Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0198975"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5294 5.93731C10.4785 6.04761 10.423 6.12962 10.3592 6.21122C10.3891 6.09987 10.402 6.04378 10.4529 5.93348C10.5038 5.82319 10.5771 5.72087 10.6363 5.63904C10.6101 5.71504 10.5806 5.8264 10.5294 5.93731Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0178486"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6009 6.14125C10.5136 6.19386 10.4494 6.20966 10.386 6.21413C10.4752 6.13265 10.5203 6.08867 10.6076 6.03607C10.695 5.98346 10.7749 5.96912 10.8387 5.95847C10.7781 6.00637 10.6888 6.08836 10.6009 6.14125Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0191855"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.44709 6.85451C9.28588 6.95208 9.15398 7.00663 9.01691 7.05221C9.16499 6.9318 9.23807 6.86888 9.39927 6.77131C9.56048 6.67374 9.72782 6.60983 9.86207 6.55936C9.75702 6.63558 9.60918 6.7564 9.44709 6.85451Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0248807"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.97157 6.81362C9.75776 6.94088 9.57598 7.00028 9.38409 7.04236C9.57218 6.87099 9.66405 6.78023 9.87786 6.65297C10.0917 6.5257 10.3237 6.45972 10.5101 6.4082C10.3742 6.5135 10.1866 6.68565 9.97157 6.81362Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0398045"
        />
        <path
          d="M8.56545 8.8738C8.57916 8.86617 8.44685 7.75216 9.31093 6.59924"
          stroke="black"
          strokeWidth="0.0803551"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.94167 6.43773C9.95423 6.46248 9.94051 6.49706 9.91032 6.5138C9.88014 6.53054 9.84537 6.52366 9.8325 6.49829C9.81962 6.47293 9.83397 6.43959 9.86416 6.42284C9.89434 6.4061 9.92911 6.41298 9.94167 6.43773Z"
          fill="#FF0000"
          stroke="black"
          strokeWidth="0.0253814"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3255 6.21312C10.338 6.23787 10.3243 6.27245 10.2941 6.28919C10.2639 6.30593 10.2292 6.29905 10.2163 6.27368C10.2034 6.24832 10.2178 6.21498 10.2479 6.19823C10.2781 6.18149 10.3129 6.18837 10.3255 6.21312Z"
          fill="#FF0000"
          stroke="black"
          strokeWidth="0.0253814"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.95875 6.89234C8.96812 6.91109 8.95116 6.94128 8.92031 6.95891C8.88947 6.97653 8.8568 6.97531 8.84719 6.95609C8.83758 6.93687 8.85502 6.90763 8.88586 6.89C8.9167 6.87238 8.94937 6.87359 8.95875 6.89234Z"
          fill="#FF0000"
          stroke="black"
          strokeWidth="0.0223779"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.06715 6.84547C9.07652 6.86422 9.05955 6.89441 9.02871 6.91203C8.99787 6.92966 8.9652 6.92844 8.95559 6.90922C8.94598 6.89 8.96341 6.86075 8.99426 6.84313C9.0251 6.8255 9.05777 6.82672 9.06715 6.84547Z"
          fill="#FF0000"
          stroke="black"
          strokeWidth="0.0223779"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.00562 6.9441C9.015 6.96285 8.99803 6.99304 8.96719 7.01066C8.93634 7.02829 8.90367 7.02707 8.89406 7.00785C8.88445 6.98863 8.90189 6.95938 8.93273 6.94176C8.96358 6.92413 8.99625 6.92535 9.00562 6.9441Z"
          fill="#FF0000"
          stroke="black"
          strokeWidth="0.0223779"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.44625 6.92184C9.46013 6.9494 9.44485 6.98779 9.41136 7.0063C9.37787 7.02481 9.33935 7.01703 9.32513 6.98878C9.3109 6.96053 9.32688 6.92351 9.36037 6.90501C9.39385 6.8865 9.43238 6.89428 9.44625 6.92184Z"
          fill="#FF0000"
          stroke="black"
          strokeWidth="0.0281766"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.52535 6.84274C9.53923 6.8703 9.52395 6.90869 9.49046 6.9272C9.45697 6.9457 9.41845 6.93793 9.40423 6.90968C9.39001 6.88142 9.40598 6.84441 9.43947 6.82591C9.47296 6.8074 9.51148 6.81518 9.52535 6.84274Z"
          fill="#FF0000"
          stroke="black"
          strokeWidth="0.0281766"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.54488 6.87985C9.55876 6.90741 9.54348 6.9458 9.50999 6.96431C9.4765 6.98281 9.43798 6.97504 9.42376 6.94679C9.40954 6.91853 9.42551 6.88152 9.459 6.86302C9.49249 6.84451 9.53101 6.85229 9.54488 6.87985Z"
          fill="#FF0000"
          stroke="black"
          strokeWidth="0.0281766"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75342 7.5166C7.75342 7.90241 7.02329 12.1506 8.85067 13.308C9.58079 13.6938 10.676 12.9222 10.676 13.308L10.3109 10.2194L7.75342 7.5166Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.48308 8.28809C8.48308 8.67389 8.11802 11.7625 9.21527 12.5363C9.9454 13.3079 11.7728 13.0987 11.7728 13.0987L10.3105 10.2193L8.48308 8.28809Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.97461 6.74961L10.3262 10.284L10.3871 10.2277L7.03086 6.69336L6.97461 6.74961Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.41808 6.35263L6.63546 6.39992L6.70184 6.46796C6.69314 6.46697 6.76821 6.53599 6.68358 6.62477C6.59895 6.71355 6.46668 6.57697 6.46668 6.57697C6.46668 6.57697 6.5148 6.80182 6.64793 6.93827C6.78105 7.07473 6.93168 7.0536 6.93168 7.0536C6.93168 7.0536 6.78163 6.92557 6.88356 6.82875C6.9856 6.73105 7.03456 6.80801 7.03456 6.80801L7.16731 6.94408L7.25242 6.8548L6.72105 6.31014L6.67292 6.0853L6.34337 6.01724L6.41819 6.35175L6.41808 6.35263Z"
          fill="#CECECC"
          stroke="black"
          strokeWidth="0.0216892"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.06295 4.83584L7.3128 5.21609L7.64102 5.29109L7.42115 5.43213L7.81525 5.40724L7.98998 5.52373L8.05673 5.4236L7.88151 5.30679L7.75328 4.93287L7.70727 5.19063L7.51218 4.91595L7.06284 4.83495L7.06295 4.83584Z"
          fill="#CECECC"
          stroke="black"
          strokeWidth="0.0224846"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.01637 5.12664C8.01637 5.14858 7.98796 5.16723 7.95529 5.16723C7.92263 5.16723 7.8928 5.14858 7.8928 5.12664C7.8928 5.10471 7.92121 5.08496 7.95529 5.08496C7.98938 5.08496 8.01637 5.10361 8.01637 5.12664ZM7.92831 5.2133C7.92831 5.60598 8.22515 7.27323 8.2493 7.31381C8.25072 7.36317 8.18112 7.38401 8.14845 7.32368C8.05471 7.13283 7.85303 5.56868 7.84593 5.20342C7.84167 5.05315 7.89848 5.04109 7.96381 5.04438C8.01637 5.04657 8.0817 5.08496 8.0817 5.13103C8.0817 5.18587 7.99932 5.22646 7.92831 5.2133Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.0443791"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.07141 5.30663C8.06072 5.32726 8.02492 5.33822 7.99419 5.33068C7.96346 5.32313 7.94449 5.29871 7.95518 5.27808C7.96587 5.25746 8.00221 5.24546 8.03427 5.25333C8.06633 5.26121 8.08263 5.28497 8.07141 5.30663ZM7.94636 5.36776C8.03908 6.1043 7.70616 7.24665 7.70857 7.29141C7.68639 7.33711 7.61024 7.34166 7.60944 7.27636C7.59368 7.23413 7.97522 6.20138 7.87369 5.33944C7.94289 5.19718 8.00221 5.19896 8.06206 5.21715C8.11042 5.23135 8.15317 5.28254 8.13072 5.32585C8.104 5.37741 8.00675 5.39654 7.94636 5.36776Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0449434"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.26094 6.53273C7.26094 6.56836 7.22466 6.59864 7.18294 6.59864C7.14122 6.59864 7.10312 6.56836 7.10312 6.53273C7.10312 6.49711 7.1394 6.46505 7.18294 6.46505C7.22648 6.46505 7.26094 6.49533 7.26094 6.53273ZM7.14847 6.67345C7.14847 7.31114 7.52761 10.0186 7.55845 10.0845C7.56026 10.1647 7.47137 10.1985 7.42965 10.1006C7.30992 9.79064 7.05233 7.25058 7.04326 6.65742C7.03781 6.41339 7.11038 6.3938 7.19382 6.39914C7.26094 6.4027 7.34439 6.46505 7.34439 6.53986C7.34439 6.62892 7.23917 6.69483 7.14847 6.67345Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.063914"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.35649 6.80359C7.34289 6.83734 7.29712 6.85553 7.25777 6.84345C7.21842 6.83138 7.19404 6.79167 7.20764 6.75792C7.22123 6.72417 7.26768 6.70429 7.30875 6.71689C7.34981 6.72949 7.37076 6.76815 7.35649 6.80359ZM7.19671 6.90435C7.31833 8.10585 6.8969 9.97309 6.90016 10.0461C6.87196 10.1209 6.77453 10.1289 6.77325 10.0224C6.7529 9.95355 7.237 8.26482 7.1036 6.85872C7.19158 6.62595 7.2675 6.62839 7.34416 6.6576C7.4061 6.6804 7.46102 6.76362 7.43247 6.83449C7.39849 6.91887 7.2741 6.95085 7.19671 6.90435Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0641563"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5748 11.4467L16.1389 14.1514L16.1857 14.0951L13.6217 11.3857L13.5748 11.4467ZM11.7936 11.8873L15.1404 15.4217L15.1967 15.3654L11.8451 11.8311L11.7842 11.8873H11.7936Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0889 15.4248L15.3671 15.7072L15.6885 15.9481L15.4534 15.6242L15.1752 15.3418L15.0889 15.4248Z"
          fill="#808080"
          stroke="black"
          strokeWidth="0.0425298"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9561 14.042L16.2343 14.3244L16.5557 14.5653L16.3206 14.2414L16.0423 13.959L15.9561 14.042Z"
          fill="#808080"
          stroke="black"
          strokeWidth="0.0425298"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7538 5.25391C15.7538 5.25391 16.0359 12.9221 14.9075 12.9221C13.7792 12.9221 13.2134 12.1156 13.2134 12.1156L13.2261 7.90109L15.7538 5.25391Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0677495"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0642 5.96875C15.0642 6.37198 15.1901 12.1151 14.6259 12.1151C14.0617 12.1151 13.2138 11.7119 13.2138 11.7119L13.2266 7.9006L15.0642 5.96875Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0677495"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6973 6.35645C14.6973 6.75967 14.6255 11.3091 14.0598 11.3091H13.2135L13.2262 7.90101L14.6973 6.35645Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.0677495"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8152 5.25957L13.2559 7.96895L13.209 7.9127L15.773 5.20801L15.8199 5.26426L15.8152 5.25957Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8597 7.28503C13.8597 7.28503 14.5885 8.20201 14.9383 8.91509C15.2877 9.62968 15.694 10.7212 15.694 10.7212C15.694 10.7212 15.465 9.64307 15.0246 8.78403C14.4473 7.70385 13.8589 7.34717 13.8597 7.28503Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0321027"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7103 6.57608C13.7103 6.57608 14.4968 7.67323 14.856 8.49165C15.2147 9.31163 15.6144 10.5437 15.6144 10.5437C15.6144 10.5437 15.42 9.35434 14.9652 8.36537C14.3659 7.11801 13.7053 6.64241 13.7103 6.57608Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0356576"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4897 5.5188C14.4897 5.5188 15.0647 7.20304 15.2413 8.24257C15.417 9.28299 15.5264 10.7134 15.5264 10.7134C15.5264 10.7134 15.6331 9.51504 15.3967 8.23913C15.0699 6.60532 14.4662 5.57055 14.4897 5.5188Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0413995"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9008 5.419C13.9008 5.419 14.6624 6.92264 14.9553 7.94407C15.2473 8.96697 15.5175 10.4425 15.5175 10.4425C15.5175 10.4425 15.4883 9.10244 15.1093 7.85901C14.6002 6.27936 13.8833 5.48676 13.9008 5.419Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0416501"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8929 5.84111C14.8929 5.84111 15.2934 7.46189 15.3983 8.43258C15.5023 9.40395 15.5399 10.7174 15.5399 10.7174C15.5399 10.7174 15.6668 9.65002 15.5224 8.45532C15.3184 6.9215 14.8723 5.88406 14.8929 5.84111Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0372517"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7885 5.93164C13.7885 5.93164 14.5485 7.22412 14.8608 8.12757C15.1725 9.03244 15.4848 10.3548 15.4848 10.3548C15.4848 10.3548 15.3975 9.12934 14.9969 8.03209C14.4628 6.64129 13.7756 5.99577 13.7885 5.93164Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0379578"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7054 6.80456C13.7054 6.80456 14.491 7.83122 14.8471 8.61839C15.2026 9.40718 15.5959 10.6054 15.5959 10.6054C15.5959 10.6054 15.4098 9.43076 14.9586 8.4815C14.3635 7.28663 13.6998 6.87156 13.7054 6.80456Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0360998"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8089 6.31635C13.8089 6.31635 14.5435 7.48781 14.8639 8.33885C15.1837 9.19142 15.5248 10.4584 15.5248 10.4584C15.5248 10.4584 15.3871 9.25453 14.9792 8.22405C14.4391 6.92176 13.8008 6.3819 13.8089 6.31635Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0356228"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6664 5.55495C14.6664 5.55495 15.1467 7.20598 15.266 8.21199C15.3845 9.21879 15.416 10.5933 15.416 10.5933C15.416 10.5933 15.5865 9.45626 15.4205 8.22005C15.1841 6.63533 14.6403 5.60267 14.6664 5.55495Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0403239"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0326 5.15048C14.0326 5.15048 14.7186 6.71907 14.9611 7.76401C15.2028 8.81033 15.401 10.3058 15.401 10.3058C15.401 10.3058 15.4361 8.96748 15.1185 7.69337C14.6874 6.0722 14.012 5.21641 14.0326 5.15048Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0417358"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0677 6.00322C15.0677 6.00322 15.3739 7.55511 15.4231 8.47508C15.4715 9.39562 15.4344 10.6331 15.4344 10.6331C15.4344 10.6331 15.621 9.63851 15.5452 8.50517C15.4293 7.04882 15.0448 6.04216 15.0677 6.00322Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0357147"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8598 5.63967C13.8598 5.63967 14.573 6.99586 14.8397 7.93097C15.1056 8.86748 15.3426 10.2277 15.3426 10.2277C15.3426 10.2277 15.337 8.97905 14.9905 7.84209C14.5235 6.39942 13.8416 5.70398 13.8598 5.63967Z"
          fill="#005B00"
          stroke="black"
          strokeWidth="0.0394041"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5599 6.74316C16.5599 6.74316 17.2901 14.08 15.0997 14.08C13.2744 14.08 13.2744 12.9226 12.9093 12.9226L13.2744 10.2198L16.562 6.74316H16.5599Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8296 7.5166C15.8296 7.90241 16.5597 12.1506 14.7323 13.308C14.0022 13.6938 12.907 12.9222 12.907 13.308L13.2721 10.2194L15.8296 7.5166Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0989 8.28809C15.0989 8.67389 15.464 11.7625 14.3668 12.5363C13.6366 13.3079 11.8093 13.0987 11.8093 13.0987L13.2716 10.2193L15.0989 8.28809Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6078 6.74961L13.2562 10.284L13.1953 10.2277L16.5516 6.69336L16.6078 6.74961Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1688 6.35263L16.9515 6.39992L16.8851 6.46796C16.8938 6.46697 16.8187 6.53599 16.9033 6.62477C16.988 6.71355 17.1202 6.57697 17.1202 6.57697C17.1202 6.57697 17.0721 6.80182 16.939 6.93827C16.8059 7.07473 16.6552 7.0536 16.6552 7.0536C16.6552 7.0536 16.8053 6.92557 16.7034 6.82875C16.6013 6.73105 16.5523 6.80801 16.5523 6.80801L16.4196 6.94408L16.3345 6.8548L16.8659 6.31014L16.914 6.0853L17.2435 6.01724L17.1687 6.35175L17.1688 6.35263Z"
          fill="#CECECC"
          stroke="black"
          strokeWidth="0.0216892"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5152 4.83584L16.2653 5.21609L15.9371 5.29109L16.157 5.43213L15.7629 5.40724L15.5881 5.52373L15.5214 5.4236L15.6966 5.30679L15.8248 4.93287L15.8709 5.19063L16.0659 4.91595L16.5153 4.83495L16.5152 4.83584Z"
          fill="#CECECC"
          stroke="black"
          strokeWidth="0.0224846"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5618 5.12567C15.5618 5.1476 15.5902 5.16625 15.6228 5.16625C15.6555 5.16625 15.6853 5.1476 15.6853 5.12567C15.6853 5.10373 15.6569 5.08399 15.6228 5.08399C15.5887 5.08399 15.5618 5.10263 15.5618 5.12567ZM15.6498 5.21232C15.6498 5.605 15.353 7.27225 15.3288 7.31284C15.3274 7.36219 15.397 7.38304 15.4297 7.32271C15.5234 7.13185 15.7251 5.56771 15.7322 5.20245C15.7365 5.05218 15.6796 5.04011 15.6143 5.0434C15.5618 5.04559 15.4964 5.08399 15.4964 5.13005C15.4964 5.1849 15.5788 5.22548 15.6498 5.21232Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.0443791"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5106 5.30663C15.5213 5.32726 15.5571 5.33822 15.5878 5.33068C15.6186 5.32313 15.6375 5.29871 15.6269 5.27808C15.6162 5.25746 15.5798 5.24546 15.5478 5.25333C15.5157 5.26121 15.4994 5.28497 15.5106 5.30663ZM15.6357 5.36776C15.543 6.1043 15.8759 7.24665 15.8735 7.29141C15.8956 7.33711 15.9718 7.34166 15.9726 7.27636C15.9884 7.23413 15.6068 6.20138 15.7083 5.33944C15.6391 5.19718 15.5798 5.19896 15.52 5.21715C15.4716 5.23135 15.4289 5.28254 15.4513 5.32585C15.478 5.37741 15.5753 5.39654 15.6357 5.36776Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0449434"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3172 6.53273C16.3172 6.56836 16.3535 6.59864 16.3952 6.59864C16.4369 6.59864 16.475 6.56836 16.475 6.53273C16.475 6.49711 16.4387 6.46505 16.3952 6.46505C16.3516 6.46505 16.3172 6.49533 16.3172 6.53273ZM16.4297 6.67345C16.4297 7.31114 16.0505 10.0186 16.0197 10.0845C16.0179 10.1647 16.1068 10.1985 16.1485 10.1006C16.2682 9.79064 16.5258 7.25058 16.5349 6.65742C16.5403 6.41339 16.4677 6.3938 16.3843 6.39914C16.3172 6.4027 16.2337 6.46505 16.2337 6.53986C16.2337 6.62892 16.339 6.69483 16.4297 6.67345Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.063914"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2255 6.80359C16.2391 6.83734 16.2849 6.85553 16.3243 6.84345C16.3636 6.83138 16.388 6.79167 16.3744 6.75792C16.3608 6.72417 16.3143 6.70429 16.2733 6.71689C16.2322 6.72949 16.2113 6.76815 16.2255 6.80359ZM16.3853 6.90435C16.2637 8.10585 16.6851 9.97309 16.6819 10.0461C16.7101 10.1209 16.8075 10.1289 16.8088 10.0224C16.8291 9.95355 16.345 8.26482 16.4784 6.85872C16.3904 6.62595 16.3145 6.62839 16.2379 6.6576C16.1759 6.6804 16.121 6.76362 16.1496 6.83449C16.1835 6.91887 16.3079 6.95085 16.3853 6.90435Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0641563"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6778 16.0115C10.8445 16.1126 11.0333 16.1659 11.2254 16.1659C11.4176 16.1659 11.6064 16.1126 11.773 16.0115V12.9229H11.0429C11.408 14.0803 11.408 15.2399 10.6758 16.0115H10.6778Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2193 12.9467C11.2193 15.1205 10.6914 15.6043 10.6914 16.0416C10.9113 16.0416 11.0579 15.8377 11.2193 15.5577C11.4392 15.1205 11.4603 12.9123 11.4392 12.9467H11.2193Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0621065"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7798 12.9462C10.7687 14.216 10.2233 15.3926 10.3264 15.6529C10.4432 15.8863 10.7798 15.1199 11.2196 15.5547C11.4394 15.1199 11.4606 12.9118 11.4394 12.9437H10.7798V12.9462Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0621065"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8356 12.9583C10.8356 14.4102 10.3301 14.507 10.3301 14.8942C10.5499 14.8942 10.8344 14.6826 10.8356 14.7023C11.0555 14.4102 11.0766 12.9353 11.0555 12.9583H10.8356Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0507581"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3956 12.9583C10.3844 13.8065 9.85154 14.5284 9.95464 14.7023C10.0726 14.8565 10.3956 14.4102 10.8353 14.7023C11.0552 14.4102 11.0763 12.9353 11.0552 12.9583H10.3956Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0507581"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9052 16.0115C12.7385 16.1126 12.5497 16.1659 12.3576 16.1659C12.1654 16.1659 11.9766 16.1126 11.81 16.0115V12.9229H12.5401C12.175 14.0803 12.175 15.2399 12.9072 16.0115H12.9052Z"
          fill="#E10000"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3627 12.9467C12.3627 15.1205 12.8906 15.6043 12.8906 16.0416C12.6708 16.0416 12.5242 15.8377 12.3627 15.5577C12.1428 15.1205 12.1217 12.9123 12.1428 12.9467H12.3627Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0621065"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8022 12.9462C12.8134 14.216 13.3587 15.3926 13.2556 15.6529C13.1388 15.8863 12.8022 15.1199 12.3625 15.5547C12.1426 15.1199 12.1215 12.9118 12.1426 12.9437H12.8022V12.9462Z"
          fill="#0000C4"
          stroke="black"
          strokeWidth="0.0621065"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7522 12.9583C12.7522 14.4102 13.2578 14.507 13.2578 14.8942C13.0379 14.8942 12.7535 14.6826 12.7522 14.7023C12.5324 14.4102 12.5113 12.9353 12.5324 12.9583H12.7522Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0507581"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1913 12.9583C13.2025 13.8065 13.7354 14.5284 13.6323 14.7023C13.5143 14.8565 13.1913 14.4102 12.7516 14.7023C12.5317 14.4102 12.5106 12.9353 12.5317 12.9583H13.1913Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0507581"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.01319 13.2549L8.63477 13.537L9.01319 13.819L9.20219 13.678L9.29669 13.819L9.39119 14.1011L9.48611 13.819L9.58061 13.678H14.6511V13.3959H9.58019L9.48569 13.2541C9.48569 13.113 9.50552 12.972 9.58061 12.972H9.95861C9.95861 12.8309 9.76961 12.5488 9.39119 12.5488C9.01319 12.5488 8.82377 12.8309 8.82377 12.972H9.20219C9.27686 12.972 9.29669 13.113 9.29669 13.2549L9.20219 13.3959L9.01277 13.2541L9.01319 13.2549Z"
          fill="#908F8A"
          stroke="black"
          strokeWidth="0.0695774"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.125 13.923H13.4394V14.0948H10.126L10.125 13.923ZM10.125 13.7503H13.4394V13.923H10.126L10.125 13.7503ZM10.125 13.5786H13.4394V13.7513H10.126L10.125 13.5786ZM10.125 13.4068H13.4394V13.5786H10.126L10.125 13.4068ZM10.125 13.2351H13.4394V13.4068H10.126L10.125 13.2351ZM10.125 13.0624H13.4394V13.2351H10.126L10.125 13.0624ZM10.125 12.8916H13.4394V13.0624H10.126L10.125 12.8916Z"
          fill="#B74D00"
          stroke="black"
          strokeWidth="0.0469113"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3223 12.8896L11.5495 14.0928H11.725L10.4986 12.8906H10.3232L10.3223 12.8896Z"
          fill="#908F8A"
          stroke="black"
          strokeWidth="0.0818061"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3223 14.0928L11.5495 12.8896H11.725L10.4986 14.0918H10.3232L10.3223 14.0928Z"
          fill="#908F8A"
          stroke="black"
          strokeWidth="0.0818061"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3027 12.8896V14.0928H10.477V12.8896H10.3027Z"
          fill="#908F8A"
          stroke="black"
          strokeWidth="0.0807917"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8887 12.8896L13.116 14.0928H13.2914L12.065 12.8906H11.8896L11.8887 12.8896Z"
          fill="#908F8A"
          stroke="black"
          strokeWidth="0.0818061"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8887 14.0928L13.116 12.8896H13.2914L12.065 14.0918H11.8896L11.8887 14.0928Z"
          fill="#908F8A"
          stroke="black"
          strokeWidth="0.0818061"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0918 12.8896V14.0928H13.266V12.8896H13.0918Z"
          fill="#908F8A"
          stroke="black"
          strokeWidth="0.0807917"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.873 12.8896V14.0928H12.0473V12.8896H11.873Z"
          fill="#908F8A"
          stroke="black"
          strokeWidth="0.0807917"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5215 12.8896V14.0928H11.6957V12.8896H11.5215Z"
          fill="#908F8A"
          stroke="black"
          strokeWidth="0.0807917"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3308 9.44828C14.3308 11.3664 13.1841 12.9227 11.7733 12.9227C10.3626 12.9227 9.21582 11.3664 9.21582 9.44828C9.21582 7.53016 10.3605 5.97168 11.7733 5.97168C13.1861 5.97168 14.3308 7.52798 14.3308 9.4461V9.44828ZM13.9658 9.44828C13.9658 11.1528 12.984 12.5369 11.7733 12.5369C10.5626 12.5369 9.58088 11.1528 9.58088 9.44828C9.58088 7.74159 10.5626 6.35748 11.7733 6.35748C12.984 6.35748 13.9658 7.74159 13.9658 9.44828Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7697 6.24632C12.4624 6.06977 12.1262 5.97168 11.7735 5.97168C11.4208 5.97168 11.0847 6.06977 10.7773 6.24414L10.9217 6.60161C11.1811 6.44361 11.4752 6.36044 11.7746 6.36044C12.0739 6.36044 12.368 6.44361 12.6274 6.60161L12.7697 6.24414V6.24632Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7746 12.6638C12.4673 12.8404 12.1311 12.9385 11.7784 12.9385C11.4257 12.9385 11.0895 12.8404 10.7822 12.666L10.9266 12.3085C11.186 12.4665 11.4801 12.5497 11.7794 12.5497C12.0788 12.5497 12.3729 12.4665 12.6323 12.3085L12.7746 12.666V12.6638Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9686 9.44551C13.9686 11.1518 12.9842 12.5346 11.7748 12.5346C10.5607 12.5346 9.58105 11.1518 9.58105 9.44551C9.58105 7.73926 10.5654 6.35645 11.7748 6.35645C12.9842 6.35645 13.9639 7.73926 13.9639 9.44551H13.9686Z"
          fill="#A7CFFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9654 9.44826C13.9881 10.0281 13.8706 10.3114 13.72 10.9152C13.6808 10.9806 13.4931 10.7735 13.3818 10.6711C13.2704 10.5686 13.2209 10.7626 13.0806 10.6057C12.9424 10.4444 12.8538 10.6493 12.7506 10.5141C12.6475 10.379 11.6926 10.3615 11.6926 10.3485C11.7874 10.3005 12.2742 10.3528 12.1958 10.1065C12.1071 9.84932 11.5564 10.0978 11.4822 9.77085C11.4306 9.4439 10.3767 9.43082 10.3004 9.35235C10.3313 9.47441 11.1213 9.52673 11.1027 9.84278C11.0841 9.97356 10.3251 10.0106 10.2509 10.1196C10.189 10.2569 10.849 10.0825 10.8717 10.2504C10.8717 10.3201 10.7748 10.2504 10.4324 10.3594C10.2591 10.4139 10.75 10.5839 10.5644 10.6776C10.3788 10.7713 9.98069 10.8127 9.99719 10.852C10.0591 11.0481 10.9191 11.2792 10.8346 11.3119C10.5293 11.4557 10.3684 11.5495 10.222 11.6323C9.79293 10.9954 9.56814 10.23 9.58057 9.44826C10.2344 9.19977 10.0962 9.14746 11.3048 9.14746C12.5134 9.14746 12.9136 9.19759 13.9654 9.44826Z"
          fill="#AFFF7B"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9659 9.44817C13.8009 9.44817 13.6277 9.52228 13.4503 9.52228C13.2709 9.52228 13.0894 9.44599 12.9037 9.44599C12.7181 9.44599 12.5057 9.54625 12.3159 9.54625C12.1241 9.54625 11.9571 9.44817 11.7652 9.44817C11.5734 9.44817 11.3816 9.52228 11.1919 9.52228C11.0021 9.52228 10.8144 9.44599 10.6309 9.44599C10.4473 9.44599 10.2658 9.52228 10.0905 9.52228C9.91518 9.52228 9.74399 9.44599 9.58105 9.44599C9.58105 9.02095 9.64293 8.61553 9.7543 8.24498C10.3112 8.28857 9.98118 7.90277 10.3112 7.90277C10.4075 7.89726 10.5039 7.91345 10.5938 7.95028C10.6838 7.98711 10.7653 8.04372 10.833 8.11638C10.8825 8.11638 11.13 7.86789 11.4084 7.90277C11.6848 7.93764 11.5837 8.49782 11.9529 8.52616C12.1386 8.67438 12.2479 8.76811 12.5036 8.82914C12.8687 8.86401 13.9144 8.77464 13.9206 8.82478C13.9507 9.03105 13.9658 9.23945 13.9659 9.44817Z"
          fill="white"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1521 11.3276C12.1521 11.2306 12.2502 11.1659 12.2502 11.0111C12.2502 10.8562 12.163 10.8528 12.1601 10.7082C12.1586 10.6486 12.2349 10.5891 12.2683 10.5823C12.3018 10.5755 12.3301 10.7082 12.3301 10.7371C12.3301 10.7661 12.296 10.6657 12.2676 10.664C12.2393 10.6623 12.1783 10.6742 12.1783 10.7031C12.1783 10.7609 12.2858 10.8324 12.2778 11.0264C12.2698 11.217 12.1855 11.2748 12.1855 11.3327C12.1855 11.3905 12.2218 11.5505 12.2218 11.5505C12.2218 11.5505 12.1514 11.4229 12.1514 11.3259L12.1521 11.3276Z"
          fill="black"
          stroke="black"
          strokeWidth="0.0395337"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2463 11.3141C12.2463 11.2171 12.1483 11.1524 12.1483 10.9976C12.1483 10.8427 12.2354 10.8393 12.2384 10.6947C12.2456 10.6266 12.1526 10.5824 12.1192 10.5773C12.0858 10.5722 12.0465 10.7134 12.0465 10.7406C12.0465 10.7679 12.0858 10.6522 12.1141 10.6505C12.1424 10.6487 12.2202 10.6607 12.2202 10.6896C12.2202 10.7474 12.1127 10.8189 12.1206 11.0129C12.1286 11.2035 12.2129 11.2613 12.2129 11.3192C12.2129 11.377 12.1766 11.537 12.1766 11.537C12.1766 11.537 12.2471 11.4093 12.2471 11.3124L12.2463 11.3141Z"
          fill="black"
          stroke="black"
          strokeWidth="0.0395337"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2486 10.5238C12.2486 10.5707 12.2252 10.6129 12.2018 10.6129C12.1689 10.6129 12.1455 10.5754 12.1455 10.5238C12.1455 10.4723 12.1689 10.4395 12.1971 10.4395C12.2252 10.4395 12.2486 10.477 12.2486 10.5238ZM12.9096 10.7816H12.9283V11.4707H12.9096V10.7816ZM13.0596 10.7254H13.0783V11.4191H13.0596V10.7254Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9424 11.1094V11.0859L13.083 11.1141V11.1281L12.9424 11.1094Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9737 11.2397C10.9737 11.2397 11.51 11.4882 11.6276 11.6364C11.7431 11.7846 11.6977 11.7846 11.6977 11.7846L12.8877 11.8347C12.8877 11.7606 13.0981 11.7606 13.1456 11.5863C13.193 11.4141 13.193 11.3639 13.193 11.3639L12.8197 11.4882L12.8403 11.2658H12.5144L12.467 11.4882L11.7657 11.4642L11.8132 10.8691L11.6729 10.8931L11.6523 11.4598C11.6276 11.4598 10.9964 11.2876 10.9717 11.2397H10.9737Z"
          fill="#B74D00"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.89648 7.6909C9.89648 7.6909 10.674 7.44678 11.796 7.46421C12.918 7.48165 13.6956 7.74321 13.6791 7.74321C13.6626 7.74321 13.4646 7.34215 13.4646 7.34215C13.4646 7.34215 12.6726 7.11328 11.7795 7.09585C10.8885 7.07841 10.111 7.27022 10.1295 7.28766L9.89648 7.6909Z"
          fill="#FEDE00"
          stroke="#FEDE00"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2965 7.1625L11.7793 7.15313V7.43438L11.3012 7.44375L11.2965 7.1625ZM10.1902 7.31719L10.0215 7.59375L10.5934 7.52344L10.5465 7.24219L10.1902 7.31719ZM10.6777 7.20938L11.1559 7.16719L11.1793 7.44844L10.7012 7.49063L10.6777 7.20938ZM12.4074 7.18125L11.9293 7.14844L11.9105 7.42969L12.3887 7.4625L12.4074 7.18125ZM13.4387 7.35938L13.6121 7.70156L13.0965 7.57031L13.1527 7.29844L13.4387 7.35938ZM13.0215 7.25625L12.548 7.19531L12.5152 7.47187L12.9887 7.53281L13.0215 7.25625Z"
          fill="#38A9F9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7955 7.84837L11.7439 7.55411L11.5872 7.80477L11.6449 7.51052L11.4119 7.67835L11.5686 7.43205L11.2922 7.49308L11.5294 7.32742L11.251 7.27293L11.5294 7.21626L11.2922 7.0506L11.5686 7.11163L11.4098 6.86533L11.6449 7.03316L11.5872 6.73891L11.7439 6.98957L11.7955 6.69531L11.8491 6.98957L12.0038 6.73891L11.9481 7.03316L12.1812 6.86533L12.0224 7.11163L12.3008 7.0506L12.0636 7.21626L12.342 7.27293L12.0636 7.32742L12.3008 7.49308L12.0224 7.43205L12.1812 7.67835L11.9481 7.51052L12.0059 7.80477L11.8491 7.55411L11.7955 7.84837Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1415 7.26733C12.1415 7.43647 12.0085 7.57288 11.8432 7.57288C11.678 7.57288 11.5449 7.43647 11.5449 7.26733C11.5449 7.09819 11.678 6.95996 11.8432 6.95996C12.0085 6.95996 12.1415 7.09819 12.1415 7.26915V7.26733Z"
          fill="#FFDF00"
          stroke="black"
          strokeWidth="0.0680768"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8121 7.19082C11.8121 7.20957 11.7699 7.22363 11.7184 7.22363C11.6668 7.22363 11.6152 7.20957 11.6152 7.19082C11.6152 7.17207 11.6621 7.15332 11.7137 7.15332C11.7652 7.15332 11.8168 7.17207 11.8168 7.19082H11.8121ZM12.0324 7.19082C12.0324 7.20957 11.9949 7.22363 11.9574 7.22363C11.9199 7.22363 11.8824 7.20957 11.8824 7.19082C11.8824 7.17207 11.9152 7.15332 11.9574 7.15332C11.9996 7.15332 12.0277 7.17207 12.0277 7.19082H12.0324Z"
          fill="black"
        />
        <path
          d="M11.7693 7.31125L11.7899 7.32303C11.7405 7.29297 11.763 7.30413 11.8403 7.38003C11.885 7.35472 11.8936 7.33158 11.9215 7.30015"
          stroke="black"
          strokeWidth="0.0755067"
        />
        <path
          d="M11.6642 7.42941L11.6807 7.44684C11.6415 7.40325 11.6601 7.42505 11.7467 7.48172C11.8292 7.49262 11.9138 7.45556 11.9633 7.39453"
          stroke="black"
          strokeWidth="0.0753879"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4766 8.00195C10.4766 8.00195 10.5094 8.2832 10.2891 8.63477C10.0781 8.98164 10.1109 8.85977 10.1109 8.85977C10.1109 8.85977 10.2094 9.04727 10.1953 9.04727C10.1812 9.04727 10.0266 8.87852 10.0266 8.87852L9.84844 9.06602C9.84844 9.06602 10.0125 8.7707 9.99375 8.7707C9.975 8.7707 9.94687 8.66758 9.94687 8.66758L10.0781 8.61602C10.0781 8.61602 10.275 8.25039 10.275 8.26445C10.275 8.27852 9.67969 8.66758 9.67969 8.66758L10.4766 8.00195ZM10.6078 8.10977C10.5891 8.10977 10.6875 8.39102 10.7719 8.53164C10.8235 8.62689 10.8523 8.73277 10.8563 8.84102L11.1375 8.98164L10.7719 8.44258L11.0063 8.52695L10.6078 8.10508V8.10977ZM10.6078 8.84102C10.6078 8.84102 10.8047 9.05195 10.8234 9.12227C10.8422 9.19258 10.8375 9.34727 10.8375 9.34727L10.7578 9.17383L10.6406 9.3332C10.6406 9.3332 10.725 9.08477 10.7062 9.0707C10.6875 9.05664 10.575 9.15508 10.575 9.15508L10.6219 9.00039C10.6219 8.98633 10.6219 8.89258 10.6078 8.84102ZM9.60938 9.3332C9.675 9.27695 9.81094 9.23945 9.81094 9.23945C9.81094 9.23945 9.72656 9.38008 9.70781 9.38008C9.68906 9.38008 9.64219 9.38008 9.61406 9.3332H9.60938ZM11.8922 8.56445C11.8922 8.56445 12.3187 8.82695 12.3187 8.8457C12.3187 8.86445 12.0375 8.71914 12.0375 8.71914L11.8922 8.56445ZM11.1187 8.01602C11.1516 8.03477 11.7469 8.52227 11.7281 8.52227C11.7094 8.52227 11.4656 8.38164 11.4656 8.40039V8.52227L11.3344 8.24102L11.3016 8.34883L11.1187 8.0207V8.01602ZM11.2687 8.80352L11.4328 9.13164L11.5969 9.09883C11.5969 9.09883 11.2828 8.80352 11.2687 8.80352ZM11.7844 8.59258L11.7984 8.90664C11.7984 8.90664 11.8922 8.9957 11.8922 8.97695C11.8922 8.9582 11.7984 8.61133 11.7797 8.59258H11.7844Z"
          fill="#B7E1FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.92773 4.32207C6.92773 4.32207 7.67305 3.91426 8.52148 3.60488C9.14204 3.37762 9.78226 3.20815 10.434 3.09863C10.6871 3.09863 11.1137 3.72676 11.184 3.72676C11.259 3.72676 11.5449 3.55332 11.9012 3.55332C12.2574 3.55332 12.473 3.83457 12.548 3.83457H13.1902C13.2605 3.83457 12.9746 3.13145 13.1902 3.16895C13.298 3.1877 14.2121 3.32832 15.0605 3.6002C15.909 3.88145 17.1137 4.36426 17.1137 4.36426C17.1137 4.36426 15.1449 4.62676 14.6199 4.55176C14.5496 4.58457 14.6199 5.01113 14.5168 4.82363C14.3527 4.78613 13.748 4.69238 13.6402 4.69238C13.5324 4.69238 13.3355 4.81426 13.0496 4.87988C12.8329 4.93512 12.6172 4.99451 12.4027 5.05801L12.8715 5.78926L12.2949 6.07051C12.2949 6.07051 11.9387 5.23145 11.7934 5.23145C11.648 5.23145 11.5824 5.82676 11.3996 5.79395C11.2215 5.75645 11.1512 5.23145 11.0105 5.09082C10.8652 4.9502 10.1105 4.90332 9.82461 4.83301C9.53867 4.7627 9.07461 4.70645 8.82617 4.63613C8.57773 4.56582 8.32461 4.81426 8.2168 4.81426C8.10898 4.81426 8.35742 4.60332 8.2543 4.56582C8.15117 4.52832 8.07617 4.67363 8.00117 4.67363C7.93086 4.67363 7.18086 4.53301 7.11055 4.49551C7.03555 4.4627 7.28867 4.32207 7.21836 4.32207H6.93242H6.92773Z"
          fill="#984000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2434 3.96063C12.2434 4.15938 12.0841 4.32063 11.8884 4.32063C11.6927 4.32063 11.5342 4.15938 11.5342 3.96063C11.5342 3.76188 11.6927 3.60156 11.8884 3.60156C12.0841 3.60156 12.2434 3.76281 12.2434 3.96063Z"
          fill="#808080"
          stroke="#772600"
          strokeWidth="0.0840173"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4834 4.04103C10.5481 3.96678 10.6282 3.85428 10.8378 3.85428C10.8861 3.83516 10.8861 3.72266 10.9981 3.72266C11.1111 3.72266 11.0782 3.83516 11.1593 3.87341C11.2395 3.91053 11.899 3.83516 11.899 3.83516C11.899 3.83516 11.9627 3.89141 11.9627 3.96678C11.9627 4.04216 11.9145 4.09728 11.899 4.09728C11.8836 4.09728 11.2395 4.04103 11.1912 4.06016C11.1429 4.07928 11.1111 4.09728 10.9981 4.09728C10.8861 4.09728 10.8532 3.96678 10.7731 3.96678C10.6929 3.96678 10.6128 3.94766 10.4834 4.04216V4.04103Z"
          fill="#984000"
          stroke="#772600"
          strokeWidth="0.147308"
        />
        <path
          d="M11.3196 5.69024C11.3099 5.69024 11.2887 5.62949 11.2559 5.57774C11.2327 5.51024 11.2037 5.54849 11.1747 5.44612C11.1786 5.34037 11.1815 5.32237 11.1747 5.22112C11.1091 5.16712 11.0811 5.15137 11.0299 5.05237C10.9488 4.97362 11.0424 4.83862 11.0579 4.73962C10.9864 4.72162 10.9517 4.86899 10.8426 4.92187C10.7634 4.98374 10.8329 4.79362 10.7943 4.68337C10.7682 4.52699 10.69 4.76212 10.661 4.82849C10.6079 4.87012 10.5915 4.92412 10.5162 4.84649C10.5162 4.78912 10.5635 4.62712 10.5432 4.59562C10.4679 4.63949 10.3694 4.76999 10.2912 4.79024C10.212 4.77112 10.3076 4.62374 10.3076 4.51462C10.2786 4.50337 10.1657 4.80487 10.1193 4.80712C10.073 4.80937 10.0932 4.51462 10.071 4.52137C10.0372 4.57762 9.96867 4.69462 9.92136 4.73512C9.82962 4.72049 9.93488 4.53824 9.9484 4.47074C9.96385 4.38974 9.86246 4.62599 9.80838 4.64062C9.76879 4.68112 9.69057 4.70812 9.66354 4.71599C9.69444 4.64624 9.84701 4.50562 9.83735 4.46512C9.74755 4.46849 9.61139 4.60574 9.53511 4.62262C9.4849 4.62262 9.41537 4.64174 9.40668 4.64062C9.41054 4.55062 9.59401 4.47637 9.62298 4.42124C9.53318 4.43812 9.36033 4.53037 9.31012 4.60349C9.25025 4.61812 9.17493 4.63724 9.11699 4.60349C9.12568 4.51912 9.26087 4.35599 9.29081 4.30199C9.20873 4.34362 9.16817 4.37624 9.08127 4.39537C9.06485 4.41449 9.0185 4.45499 9.03298 4.41449C9.05906 4.33574 9.09768 4.30199 9.12955 4.24574C9.05712 4.26149 9.03009 4.30987 8.95284 4.35824C8.90359 4.36049 8.76261 4.52587 8.71529 4.52812C8.63521 4.60166 8.54173 4.65285 8.44202 4.67774C8.36863 4.69349 8.33291 4.71149 8.29718 4.75312C8.33387 4.67774 8.38988 4.60687 8.44202 4.56637C8.47385 4.49808 8.52505 4.44479 8.58687 4.41562C8.60521 4.38974 8.65542 4.38299 8.60232 4.37849C8.55693 4.42574 8.47968 4.47974 8.44202 4.51012C8.39277 4.54612 8.3358 4.58212 8.31263 4.56637C8.3387 4.48537 8.38505 4.46512 8.42561 4.39762C8.51058 4.33462 8.42561 4.37512 8.36091 4.39762C8.31939 4.44037 8.24503 4.47299 8.1842 4.51012C8.11661 4.53037 8.07122 4.57762 7.99107 4.60349C7.99107 4.63049 8.01425 4.55512 8.02391 4.52812C8.08957 4.44487 8.10695 4.42124 8.1842 4.39762C8.20351 4.36499 8.22669 4.37849 8.16875 4.37849C8.12433 4.42349 8.06446 4.44824 8.00749 4.49099C7.95052 4.50562 7.87617 4.51012 7.79892 4.51012C7.69849 4.52362 7.70718 4.53262 7.79892 4.47187C7.85009 4.41562 7.89258 4.43024 7.89548 4.35937C7.83464 4.41112 7.76029 4.44937 7.68594 4.49099C7.62414 4.49324 7.60772 4.51012 7.54109 4.51012C7.57296 4.47187 7.59227 4.42349 7.63766 4.39762C7.70525 4.31099 7.59517 4.38074 7.57296 4.39762H7.33155C7.28907 4.46062 7.32962 4.39762 7.36438 4.35937C7.40591 4.33462 7.44936 4.30199 7.44453 4.28512C7.39625 4.33349 7.34121 4.35599 7.29969 4.39762C7.25527 4.41337 7.20312 4.42012 7.20312 4.43474C7.23885 4.37512 7.29583 4.33799 7.33252 4.28512C7.38659 4.27162 7.43294 4.25137 7.44453 4.22887H7.21954H7.37983C7.46191 4.22887 7.53144 4.21987 7.60579 4.20974C7.73325 4.18499 7.5942 4.17262 7.52468 4.17262C7.51212 4.14337 7.56523 4.12762 7.62124 4.11637C7.66952 4.08937 7.73036 4.06574 7.7825 4.04099C7.82853 4.02466 7.87192 3.99957 7.91093 3.96674C7.86265 3.96899 7.86265 3.98249 7.81437 3.98474C7.88679 3.97912 7.93797 3.96674 8.02391 3.96674C8.09468 3.93956 8.16429 3.9084 8.23248 3.87337C8.26145 3.83287 8.27304 3.83512 8.20062 3.83512C8.26531 3.81149 8.35705 3.79912 8.40919 3.77887C8.47575 3.76262 8.54053 3.73772 8.60232 3.70462C8.64963 3.66749 8.67667 3.62362 8.73074 3.59212C8.79351 3.64162 8.79447 3.64837 8.90745 3.64837C8.99822 3.64724 9.05423 3.62137 9.10058 3.57299C9.1701 3.55049 9.18266 3.51224 9.26184 3.49874C9.33624 3.51236 9.41152 3.51838 9.48683 3.51674C9.56408 3.49312 9.63843 3.44924 9.6954 3.40424C9.74465 3.37612 9.80355 3.33562 9.85666 3.31087C9.9146 3.34574 9.96095 3.37387 10.0334 3.38624C10.1077 3.37274 10.1473 3.32999 10.2101 3.31087C10.2488 3.26286 10.2995 3.23021 10.3549 3.21749C10.4486 3.16349 10.4418 3.23437 10.4834 3.29174C10.5316 3.35024 10.5934 3.32212 10.6601 3.34799C10.6977 3.41549 10.7248 3.46049 10.773 3.49762C10.8107 3.55162 10.8551 3.56512 10.9343 3.57299C10.9633 3.61799 10.9401 3.64949 10.998 3.66637C11.0212 3.69562 11.0608 3.70687 11.0946 3.72262M12.4455 4.00387H12.7024C12.7951 4.00499 12.8269 4.03762 12.9119 4.04099H13.1369C13.219 4.03762 13.2624 4.01512 13.3455 4.00387C13.4855 4.00162 13.4382 3.98924 13.4102 3.89137C13.3851 3.81824 13.3812 3.78337 13.3455 3.74174C13.3319 3.65174 13.301 3.62024 13.2972 3.51674C13.2827 3.43799 13.2557 3.38512 13.2817 3.29174C13.3184 3.35587 13.3329 3.38174 13.4266 3.38624C13.5231 3.38624 13.5608 3.38287 13.6197 3.42337C13.6641 3.47849 13.724 3.46049 13.8128 3.46049C13.8862 3.47624 13.8988 3.52012 13.9567 3.55387C14.0253 3.59887 14.0697 3.61012 14.1653 3.61012C14.2425 3.62699 14.3101 3.63937 14.3584 3.66637C14.3999 3.72374 14.4646 3.73837 14.5515 3.74174C14.5998 3.74174 14.6384 3.73612 14.68 3.72262C14.7543 3.72712 14.8296 3.72262 14.9214 3.72262C14.9812 3.80362 14.9948 3.83399 15.0981 3.83512C15.1695 3.89362 15.2294 3.90262 15.2912 3.92849H15.5326C15.6195 3.93637 15.6465 3.97799 15.7257 4.00387C15.7937 4.03963 15.8633 4.07081 15.9343 4.09724C16.0034 4.11182 16.0736 4.11823 16.1438 4.11637C16.2027 4.15237 16.2752 4.15462 16.3206 4.19062C16.3872 4.20749 16.478 4.22774 16.5291 4.24687C16.6141 4.26037 16.6469 4.29187 16.7223 4.30312C16.787 4.32562 16.701 4.34362 16.6576 4.35937C16.5629 4.35599 16.5562 4.31437 16.4644 4.30312C16.4162 4.27049 16.3428 4.27499 16.2713 4.24687H16.2559C16.3196 4.29187 16.3814 4.31999 16.3524 4.39762C16.2703 4.39762 16.2037 4.38524 16.1274 4.37849C16.0463 4.36049 16.0096 4.34137 15.9189 4.34137C16.0096 4.31549 16.0328 4.34362 16.0956 4.37849C16.1187 4.46849 16.0685 4.43474 15.9826 4.43474C15.9092 4.40437 15.8648 4.36724 15.774 4.35937H15.5809C15.6765 4.36387 15.6968 4.40549 15.7576 4.45387C15.7624 4.48312 15.7566 4.48087 15.7093 4.49099C15.6591 4.44037 15.5944 4.42349 15.5162 4.39762C15.4399 4.39424 15.3598 4.38637 15.2912 4.35937C15.2439 4.35599 15.2516 4.29074 15.3559 4.39762C15.4187 4.44037 15.4409 4.47637 15.436 4.51012C15.353 4.48537 15.3124 4.44712 15.2593 4.41562C15.1871 4.38643 15.1107 4.37382 15.0343 4.37849C14.9513 4.35262 15.043 4.33799 15.0981 4.43474C15.2178 4.53374 15.0826 4.49099 15.0343 4.47187C14.9619 4.44824 14.8866 4.41337 14.8248 4.39762C14.7765 4.38074 14.734 4.36499 14.68 4.35937C14.764 4.36837 14.792 4.40324 14.8248 4.47187C14.9098 4.53937 14.8209 4.50674 14.7447 4.49099C14.6964 4.44149 14.6336 4.41562 14.5998 4.35937C14.5197 4.31324 14.5168 4.25812 14.5679 4.37849C14.5805 4.41674 14.5776 4.49999 14.5834 4.51012C14.5245 4.43474 14.537 4.41562 14.4714 4.41562C14.426 4.37962 14.3603 4.35149 14.3265 4.30312C14.2647 4.29637 14.2609 4.27049 14.1981 4.24687C14.2493 4.31774 14.3178 4.38749 14.3584 4.45387C14.4318 4.50112 14.4521 4.54387 14.5032 4.58437C14.5235 4.62599 14.5805 4.65974 14.5197 4.60349C14.4501 4.52474 14.399 4.50562 14.2947 4.45387C14.2348 4.39762 14.2136 4.37512 14.1498 4.32224C14.0629 4.28962 14.0967 4.27162 14.1498 4.37849C14.2107 4.44374 14.257 4.51574 14.3101 4.56637C14.3518 4.62433 14.4006 4.67475 14.455 4.71599C14.4695 4.74074 14.5129 4.74524 14.455 4.75312C14.4067 4.70137 14.3352 4.66874 14.2783 4.62149C14.1981 4.59562 14.1605 4.54724 14.1015 4.49099C14.0629 4.42462 14.0011 4.37399 13.9567 4.32224C13.864 4.27949 13.9751 4.36274 14.005 4.41562C14.0253 4.48424 14.0513 4.53937 14.0687 4.60349C14.0958 4.66537 13.9876 4.58887 13.9567 4.56637C13.8932 4.51841 13.8218 4.48624 13.7472 4.47187C13.6832 4.45694 13.6188 4.44456 13.554 4.43474C13.4816 4.41224 13.5936 4.48874 13.6352 4.56637C13.7163 4.65524 13.555 4.58212 13.5067 4.56637C13.427 4.55059 13.3461 4.54418 13.2653 4.54724C13.162 4.55399 13.2363 4.56974 13.2653 4.62149C13.2972 4.65074 13.3194 4.71149 13.3136 4.73399C13.246 4.72274 13.1881 4.70024 13.1041 4.69687C13.0365 4.72274 12.9563 4.71599 12.8791 4.71599C12.8762 4.76324 12.8936 4.72274 12.9273 4.77224C12.9834 4.79812 13.02 4.82962 13.0085 4.86562H12.5421C12.4909 4.88137 12.5527 4.87349 12.5903 4.94099C12.5691 5.00174 12.5421 4.97812 12.4774 4.97812C12.4339 4.95787 12.346 4.94887 12.3007 4.92187C12.2553 4.92187 12.2591 4.90837 12.2205 4.90274C12.3557 5.01524 12.2881 4.98712 12.3654 5.07149C12.3779 5.07712 12.4088 5.09062 12.3808 5.09062L12.4455 4.00387Z"
          stroke="#772600"
          strokeWidth="0.0972786"
        />
        <path
          d="M12.2606 5.2125V5.2215C12.2606 5.19563 12.2606 5.21025 12.277 5.25975C12.2828 5.30025 12.2692 5.29575 12.2528 5.325C12.2499 5.36663 12.2451 5.397 12.2451 5.4465C12.2393 5.487 12.22 5.52525 12.2046 5.559C12.1891 5.59388 12.1225 5.61413 12.1244 5.6625C12.0858 5.67488 12.0848 5.64563 12.0838 5.59613C12.0607 5.56575 12.0529 5.52413 12.0356 5.48363C12.0259 5.44538 12.0027 5.41613 11.9873 5.37113C11.9641 5.3295 11.9438 5.31713 11.9236 5.26875C11.9149 5.24625 11.9168 5.217 11.8994 5.2035C11.8733 5.16413 11.856 5.1585 11.8106 5.15625C11.7758 5.16525 11.7623 5.18325 11.7304 5.19338C11.7053 5.2035 11.657 5.20013 11.6261 5.2125C11.6184 5.22713 11.6416 5.235 11.6503 5.26875C11.629 5.289 11.6213 5.32388 11.6097 5.35313C11.5904 5.38125 11.5779 5.39475 11.5692 5.4375C11.5827 5.46338 11.5711 5.49825 11.5537 5.52188C11.5479 5.56463 11.5296 5.58825 11.5209 5.62425C11.4958 5.64563 11.4861 5.66475 11.4649 5.69963C11.4465 5.73 11.4301 5.72775 11.3847 5.72775C11.349 5.7165 11.3442 5.694 11.3123 5.6805C11.3094 5.66925 11.3065 5.66588 11.2959 5.6625"
          stroke="#782600"
          strokeWidth="0.086161"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3533 5.59648C11.3533 5.59648 11.3393 5.76992 11.2268 5.88711C11.1143 6.0043 10.8799 6.14023 10.8799 6.14023C10.8799 6.14023 11.1939 5.99492 11.2268 6.02305C11.2596 6.05586 11.0252 6.31836 11.0252 6.31836C11.0252 6.31836 11.3299 6.0418 11.3721 6.0418C11.4143 6.0418 11.4986 6.30898 11.5314 6.3043C11.5643 6.29961 11.4611 5.9668 11.4752 5.91523C11.4893 5.86367 11.4752 5.58711 11.4752 5.58711L11.3533 5.59648ZM12.0799 5.57305C12.0799 5.57305 12.0658 5.76055 11.9486 5.88242C11.8314 6.0043 11.6018 6.1543 11.6018 6.1543C11.6018 6.1543 11.9205 5.99492 11.9486 6.03242C11.9814 6.06523 11.7471 6.3418 11.7471 6.3418C11.7471 6.3418 12.0564 6.05117 12.0939 6.05117C12.1314 6.05117 12.2252 6.33242 12.258 6.33242C12.2908 6.32305 12.183 5.9668 12.2018 5.91055C12.2158 5.85898 12.2018 5.55898 12.2018 5.55898L12.0799 5.57305ZM11.0627 3.87148C11.0627 3.90898 11.0299 3.93711 10.9877 3.93711C10.9455 3.93711 10.9127 3.90898 10.9127 3.87148C10.9127 3.83398 10.9455 3.81055 10.9877 3.81055C11.0299 3.81055 11.0627 3.83867 11.0627 3.87148Z"
          fill="#812E00"
        />
      </g>
      <rect
        x="0.25"
        y="0.25"
        width="23.5"
        height="23.5"
        rx="11.75"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.5"
      />
      <defs>
        <clipPath id="clip0_602_7148">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
